import type { AsyncData } from "#app";
import type { IModelListQueryParamsRequest, IModelResponse } from "~/services/base/dto/base.dto";
import type { IModelApplicationAsso, IModelApplicationResponse } from "./dto/application.dto";


export class ApplicationRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getApplication(params: IModelListQueryParamsRequest): Promise<AsyncData<IModelResponse<IModelApplicationAsso[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/application-asso/application-all`, this.configService, {
      params,
    });
    return dataResult;
  }

  async getApplicationAssoById(id: string | number): Promise<AsyncData<IModelResponse<IModelApplicationAsso>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/application-asso/application-all/${id}`, this.configService);
    return dataResult;
  }

  async createApplication(params: any): Promise<AsyncData<IModelResponse<IModelApplicationAsso>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/application-asso/application-all`, this.configService, {
      method: 'POST',
      body: {
        data: params,
      }
    });
    return dataResult;
  }

  async updateApplication(params: any): Promise<AsyncData<IModelResponse<IModelApplicationAsso>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/application-asso/application-all`, this.configService, {
      method: 'PUT',
      body: {
        data: params,
      }
    });
    return dataResult;
  }

  async changeStatusApplication(params: any): Promise<AsyncData<IModelResponse<IModelApplicationAsso>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/application`, this.configService, {
      method: 'PUT',
      body: {
        data: params,
      }
    });
    return dataResult;
  }

  async createApiKey(applicationId: number, name: string): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/application-api-key`, this.configService, {
      method: 'POST',
      body: {
        data: {applicationId, name}
      }
    });
    return dataResult;
  }

  async deleteApiKey(apiKeyId: number): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/application-api-key/${apiKeyId}`, this.configService, {
      method: 'DELETE'
    });
    return dataResult;
  }

  // async initialApplication(params: any): Promise<AsyncData<any, any>> {
  //   const dataResult = await this.api(`${this.llmService}/v1/application-association/application/${params.id}/initial-llm`, this.configService, {
  //     method: 'PUT',
  //   });
  //   return dataResult;
  // }

  // async appendApplication(params: any): Promise<AsyncData<any, any>> {
  //   const dataResult = await this.api(`${this.llmService}/v1/application-association/application/${params.id}/append-llm`, this.configService, {
  //     method: 'PUT',
  //     body: {
  //       data: params,
  //     }
  //   });
  //   return dataResult;
  // }

  // async deleteApplication(params: any): Promise<AsyncData<any, any>> {
  //   const dataResult = await this.api(`${this.llmService}/v1/application-association/application/${params.id}`, this.configService, {
  //     method: 'DELETE'
  //   });
  //   return dataResult;
  // }
}
